'use strict';

const $ = require('jquery');

window.jQuery = $;
window.$ = $;

// require('jquery-ellipsis');
